import * as React from 'react';
import * as _ from "lodash";
import {Props} from "./types";
import {CarrierSelector} from "./carrier-selector";
import { useMaCompaniesQuery } from '@coverright/data-access/medicare';
import { mainBackendApolloClient } from '@coverright/data-access/apollo-clients';
import { SnpType } from '@coverright/data-access/types/enrollment';
import { Tooltip } from '@coverright/ui/inputs';
import { useMemo } from 'react';
import { Box } from '@mui/material';

export const MaCarrierSelector = (props: Props) => {
  const {zip, county, planYear} = props;
  const {data, loading} = useMaCompaniesQuery({
    client: mainBackendApolloClient,
    variables: {
      filter: {zip, countyName: county, planYear, showAllPlans: true},
      snpFilter: {zip, countyName: county, planYear, showAllPlans: true, SNPTypes: [SnpType.DSnp]}
    },
    skip: !county || !zip || !planYear
  })

  const grouped = _.groupBy([...(data?.companies || []), ...(data?.snpCompanies || [])], 'name');

  const companies = Object.keys(grouped).reduce((previousValue, currentValue) => {
    return [...previousValue, {name: currentValue, count: _.sumBy(grouped[currentValue], 'count')}];
  }, [] as any[]).filter((c: any) => c.count).map((c: any) => `${c.name} (${c.count})`) || []

  const helperTip = useMemo(() => {
    const fields = [];
    if (!zip || !county) {
      fields.push('zip')
    }
    if (!planYear) {
      fields.push('effective date')
    }

    if (fields.length) {
      return `You have to fill ${fields.join(', ')} to select carrier`
    }

    return ''
  }, [zip, county, planYear])

  return <Tooltip sx={{flex: 1, display: 'flex'}} title={helperTip}>
    <Box>
      <CarrierSelector {...props} loading={loading} companies={companies} />
    </Box>
  </Tooltip>
};
